export const PROJECT_LIST_ARCHIVE = [
  {
    title: 'Motion Reel',
    imgSrc: require('../ProjectPages/assets/MotionReel/cover.png'),
    vidSrc: require('../ProjectPages/assets/MotionReel/2022MotionReel.mp4'),
    timeStart: 13,
    timeEnd: 23,
    pgSrc: '/motion-reel',
    category: ['Motion Design', 'Creative Dev'],
  },
  {
    title: 'Lincoln Center Infoscape',
    imgSrc: require('../ProjectPages/assets/LincolnCenter/lc_logo.png'),
    pgSrc: '/lincoln-center',
    category: ['Branding', 'Motion Design', 'Creative Dev'],
  },
  {
    title: 'Arium Networks',
    imgSrc: require('../ProjectPages/assets/Arium/hero.png'),
    vidSrc: require('../ProjectPages/assets/Arium/animatedlogo.mp4'),
    timeStart: 0,
    pgSrc: '/arium',
    category: ['Branding', 'Motion Design', 'Web Design'],
  },
  {
    title: 'Quilt',
    imgSrc: require('../ProjectPages/assets/Quilt/logo.png'),
    vidSrc: require('../ProjectPages/assets/Quilt/animatedlogo.mp4'),
    timeStart: 0,
    pgSrc: '/quilt',
    category: ['Branding', 'Product Design'],
  },
  {
    title: 'C7 Nova',
    imgSrc: require('../ProjectPages/assets/C7/hero.png'),
    vidSrc: require('../ProjectPages/assets/C7/speakers.mp4'),
    timeStart: 0,
    pgSrc: '/c7',
    category: ['3D Design', 'Motion Design'],
  },
  {
    title: 'WPP House @SXSW',
    imgSrc: require('../assets/wpphouse_cover.png'),
    vidSrc: require('../ProjectPages/assets/WPPHouse/vortex.mov'),
    timeStart: 0,
    pgSrc: '/wpp-house',
    category: ['Web Design', 'Branding', 'Creative Dev'],
  },
  {
    title: 'Lucky Tiger',
    imgSrc: require('../assets/luckytiger_cover.jpeg'),
    vidSrc: require('../ProjectPages/assets/LuckyTiger/cny_su.mov'),
    timeStart: 1,
    pgSrc: '/lucky-tiger',
    category: ['Web Design', 'Creative Dev'],
  },
  {
    title: 'World Cheese Award',
    imgSrc: require('../ProjectPages/assets/WorldCheeseAward/worldcheeseaward_hero.png'),
    vidSrc: require('../ProjectPages/assets/WorldCheeseAward/LOGO.mp4'),
    timeStart: 0,
    pgSrc: '/world-cheese-award',
    category: ['Branding', 'Motion Design'],
  },
  {
    title: 'Colaj.ai',
    imgSrc: require('../ProjectPages/assets/Colaj/colaj_hero.png'),
    pgSrc: '/colaj',
    category: ['Branding', 'Product Design'],
  },
  {
    title: 'Signature Spectrum',
    imgSrc: require('../assets/signature_hero.png'),
    vidSrc: require('../ProjectPages/assets/SignatureSpectrum/signature_mainVideo.mp4'),
    timeStart: 0,
    pgSrc: '/signature-spectrum',
    category: ['Web Design', 'Creative Dev'],
  },

  {
    title: 'K-5',
    imgSrc: require('../ProjectPages/assets/K5/k5_cover.png'),
    vidSrc: require('../ProjectPages/assets/K5/k-5.mp4'),
    timeStart: 7,
    timeEnd: 17,
    pgSrc: '/k5',
    category: ['Creative Dev', 'Web Design'],
  },
  {
    title: 'TapType',
    imgSrc: require('../assets/taptype_cover.png'),
    vidSrc: require('../ProjectPages/assets/TapType/Barbed.mp4'),
    timeStart: 0,
    timeEnd: 10,
    pgSrc: '/taptype',
    category: ['Creative Dev'],
  },

  // {
  //   title: 'Hearts & Bones',
  //   imgSrc: require('../ProjectPages/assets/HeartsAndBones/H&B HeroImage.jpg'),
  //   pgSrc: '/hearts-and-bones',
  //   category: ['Web Design'],
  // },
  // {
  //   title: 'Lash In Bloom',
  //   imgSrc: require('../ProjectPages/assets/LashInBloom/Lash in Bloom_TN.png'),
  //   pgSrc: '/lash-in-bloom',
  //   category: ['Branding', 'Web Design'],
  // },
];
